import * as yup from 'yup';
import {
  passwordSchema,
  confirmPasswordSchema,
} from '../schemas/password-schemas';

export const resetPasswordSubmitFormSchema = yup.object().shape({
  newPassword: passwordSchema(),
  newPassword2: confirmPasswordSchema('newPassword'),
});
